import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { login } from "../actions/authActions";
import Spinner from "./Spinner";
import { useHistory } from "react-router-dom";
import styles from "./Landing.module.scss";

const MASQOTAR_URL = "https://masqotar.com";

const Login = ({ props, auth: { isAuthenticated, loading, error }, login }) => {
  let history = useHistory();
  const [showLogin, setShowLogin] = useState(false);

  useEffect(() => {
    if (isAuthenticated) {
      props.history.push("/dashboard");
    }

    // eslint-disable-next-line
  }, [error, isAuthenticated, props]);

  const [loginUser, setLoginUser] = useState({
    username: "",
    password: "",
  });
  const [isLoggingIn, setIsLoggingIn] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const { username, password } = loginUser;
  const onChange = (e) => setLoginUser({ ...loginUser, [e.target.name]: e.target.value.trim() });

  const LogIn = async (e) => {
    setErrorMessage("");
    if (username === "" || password === "") {
      setErrorMessage("Please fill in all fields");
    } else {
      setIsLoggingIn(true);
      const loginResponse = await login({ username, password });
      if (loginResponse === "BAD_CREDS") {
        setErrorMessage("Invalid credentials");
        setLoginUser({ ...loginUser, password: "" });
      }
      setIsLoggingIn(false);
    }
  };
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      LogIn();
    }
  };

  const openLogin = () => {
    setShowLogin(true);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (loading) {
    return <Spinner />;
  }

  return (
    <div className={styles.page}>
      {/* ambient background */}
      <div className={styles.backdrop} aria-hidden="true">
        <div className={styles.grid}></div>
        <div className={`${styles.glow} ${styles.glowCyan}`}></div>
        <div className={`${styles.glow} ${styles.glowViolet}`}></div>
      </div>

      {/* ---------------- nav ---------------- */}
      <header className={styles.nav}>
        <div className={styles.navInner}>
          <div className={styles.brand} onClick={() => setShowLogin(false)}>
            <span className={styles.brandMark}>G</span>
            GYDRUS SAS
          </div>
          {!showLogin && (
            <nav className={styles.navLinks}>
              <a href="#productos">Nuestros Productos</a>
              <a href="#porque">¿Por qué elegirnos?</a>
              <a href="/terms-of-use">Términos de Uso</a>
            </nav>
          )}
          {!showLogin && (
            <button className={styles.navCta} onClick={openLogin}>
              Acceder
            </button>
          )}
        </div>
      </header>

      {showLogin ? (
        /* ---------------- login ---------------- */
        <section className={styles.loginWrap}>
          <div className={`${styles.loginCard} ${styles.rise}`} onKeyDown={handleKeyDown}>
            <button className={styles.backLink} onClick={() => setShowLogin(false)}>
              <i className="fas fa-arrow-left"></i>
              Volver a Productos
            </button>

            <h1 className={styles.loginTitle}>Sign In - Sistema Principal</h1>

            <div className={styles.loginFields}>
              <div className={styles.field}>
                <i className="fas fa-user"></i>
                <input type="username" name="username" value={username} onChange={onChange} placeholder="Username" autoFocus={true} />
              </div>
              <div className={styles.field}>
                <i className="fas fa-lock"></i>
                <input type="password" name="password" id="password" value={password} onChange={onChange} placeholder="Password" />
              </div>
            </div>

            <button className={`${styles.btn} ${styles.btnPrimary} ${styles.loginButton}`} onClick={LogIn}>
              {isLoggingIn ? (
                <span className={styles.dots}>
                  <span></span>
                  <span></span>
                  <span></span>
                </span>
              ) : (
                <>
                  <span>Sign In</span>
                  <i className="fa-solid fa-arrow-right-to-bracket"></i>
                </>
              )}
            </button>

            {errorMessage && (
              <div className={styles.loginError}>
                <i className="far fa-times-circle"></i>
                <span>{errorMessage}</span>
              </div>
            )}

            <p className={styles.loginFoot}>
              Don't have an account? <span onClick={() => history.push("/register")}>Register</span>
            </p>
          </div>
        </section>
      ) : (
        <main>
          {/* ---------------- hero ---------------- */}
          <section className={`${styles.hero} ${styles.rise}`}>
            <div className={styles.eyebrow}>
              <i className="fas fa-location-dot"></i>
              Montevideo, Uruguay
            </div>
            <h1 className={styles.heroTitle}>GYDRUS SAS</h1>
            <p className={styles.heroSub}>Soluciones de Software Empresarial</p>

            <div className={styles.heroActions}>
              <a href="#productos" className={`${styles.btn} ${styles.btnPrimary}`}>
                <i className="fas fa-layer-group"></i>
                Nuestros Productos
              </a>
              <button className={`${styles.btn} ${styles.btnGhost}`} onClick={openLogin}>
                <i className="fa-solid fa-arrow-right-to-bracket"></i>
                Acceder
              </button>
            </div>
          </section>

          {/* ---------------- products ---------------- */}
          <section className={styles.section} id="productos">
            <div className={styles.sectionHead}>
              <div className={styles.kicker}>Software</div>
              <h2 className={styles.sectionTitle}>Nuestros Productos</h2>
              <p className={styles.sectionLead}>Plataformas propias, en producción y operadas por GYDRUS SAS.</p>
            </div>

            <div className={styles.productGrid}>
              <div className={styles.productCard} onClick={openLogin}>
                <div className={styles.productIcon}>
                  <i className="fa-solid fa-chart-column"></i>
                </div>
                <h3 className={styles.productName}>Sistema Principal</h3>
                <p className={styles.productDesc}>Plataforma de gestión empresarial</p>
                <span className={styles.productLink}>
                  Acceder
                  <i className="fas fa-arrow-right"></i>
                </span>
              </div>

              <a href={MASQOTAR_URL} target="_blank" rel="noopener noreferrer" className={styles.productCard}>
                <div className={styles.productIcon}>
                  <i className="fa-solid fa-paw"></i>
                </div>
                <h3 className={styles.productName}>Masqotar</h3>
                <p className={styles.productDesc}>Sistema de identificación inteligente para mascotas</p>
                <span className={styles.productLink}>
                  Visitar sitio
                  <i className="fas fa-arrow-right"></i>
                </span>
              </a>
            </div>
          </section>

          {/* ---------------- why us ---------------- */}
          <section className={styles.section} id="porque">
            <div className={styles.whyCard}>
              <div className={styles.kicker}>GYDRUS SAS</div>
              <h2 className={styles.sectionTitle}>¿Por qué elegirnos?</h2>
              <p className={styles.whyText}>Ofrecemos soluciones tecnológicas innovadoras para empresas y particulares. Nuestros sistemas están diseñados con los más altos estándares de calidad, seguridad y facilidad de uso.</p>

              <div className={styles.whyPoints}>
                <div className={styles.whyPoint}>
                  <i className="fas fa-lightbulb"></i>
                  <span>Innovación</span>
                </div>
                <div className={styles.whyPoint}>
                  <i className="fas fa-medal"></i>
                  <span>Calidad</span>
                </div>
                <div className={styles.whyPoint}>
                  <i className="fas fa-shield-halved"></i>
                  <span>Seguridad</span>
                </div>
                <div className={styles.whyPoint}>
                  <i className="fas fa-wand-magic-sparkles"></i>
                  <span>Facilidad de uso</span>
                </div>
              </div>
            </div>
          </section>
        </main>
      )}

      {/* ---------------- footer ---------------- */}
      <footer className={styles.footer}>
        <div className={styles.footerInner}>
          <div className={styles.footerTop}>
            <div>
              <div className={styles.brand}>
                <span className={styles.brandMark}>G</span>
                GYDRUS SAS
              </div>
              <p className={styles.footerNote}>Todos los productos, incluyendo Masqotar, son operados por GYDRUS SAS</p>
            </div>

            <div className={styles.footerMeta}>
              <div>
                <i className="fa fa-map-marker"></i>
                Montevideo, Uruguay
              </div>
              <div>RUT: 219827060010</div>
              <div>
                <a href="/terms-of-use">Términos de Uso</a>
              </div>
            </div>
          </div>

          <div className={styles.footerBottom}>
            <span>© 2025 GYDRUS SAS - RUT: 219827060010</span>
            <span>
              More amazing software at{" "}
              <a target="_blank" rel="noopener noreferrer" href="https://www.elitepvpers.com">
                https://www.elitepvpers.com
              </a>
            </span>
          </div>
        </div>
      </footer>
    </div>
  );
};

const mapStateToProps = (state, props) => ({
  props,
  auth: state.auth,
});

export default connect(mapStateToProps, { login })(Login);
